import React from 'react';

export const FinanceSummaryCard = ({ grandTotals }) => {
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 0
    }).format(amount || 0);
  };

  return (
    <div className="finance-summary-cards">
      <div className="summary-card">
        <div className="summary-card-header">Total Students</div>
        <div className="summary-card-value">{grandTotals.total_students || 0}</div>
      </div>
      
      <div className="summary-card">
        <div className="summary-card-header">Total Imposed Fees</div>
        <div className="summary-card-value">{formatCurrency(grandTotals.total_imposed_fees)}</div>
      </div>
      
      <div className="summary-card">
        <div className="summary-card-header">Total Scheduled Fees</div>
        <div className="summary-card-value">{formatCurrency(grandTotals.total_scheduled_fee)}</div>
      </div>
      
      <div className="summary-card">
        <div className="summary-card-header">Total Paid Fees</div>
        <div className="summary-card-value success">{formatCurrency(grandTotals.total_paid_fees)}</div>
      </div>
    </div>
  );
};
